// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"fecbeccf","81":"de88b4bc","245":"e444d958","377":"96b2a721","450":"317a8442","530":"c6a75221","533":"66cb4d40","640":"54c6930b","715":"b562e684","965":"184a79f6"}[chunkId] + ".chunk.js";
};